import { render, staticRenderFns } from "./Movimentacao.vue?vue&type=template&id=6f06b26a&scoped=true&"
import script from "./Movimentacao.vue?vue&type=script&lang=js&"
export * from "./Movimentacao.vue?vue&type=script&lang=js&"
import style0 from "./Movimentacao.vue?vue&type=style&index=0&id=6f06b26a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06b26a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f06b26a')) {
      api.createRecord('6f06b26a', component.options)
    } else {
      api.reload('6f06b26a', component.options)
    }
    module.hot.accept("./Movimentacao.vue?vue&type=template&id=6f06b26a&scoped=true&", function () {
      api.rerender('6f06b26a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Carteira/Movimentacao.vue"
export default component.exports